<script setup>
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const loading = ref(true)
const error = ref(false)
const errorMessage = ref(undefined)
const paylineToken = ref(undefined)

const route = useRoute()
const router = useRouter()

defineComponent({
  name: 'Paiement'
})

onMounted(() => {
  paylineToken.value = route.params.paylineToken

  axios.post('/commandes/finaliser/' + paylineToken.value, {})
    .then(
      succes => {
        loading.value = false
        // 202 == ignored from multiple call
        if (succes.status === 202) {
          errorMessage.value = "Ce paiement a déjà été traité"
          return
        }
        if (succes.data.typeVente === 'VENTE') {
          if(succes.data.support === 'NFC') {
                router.push({
                  name: 'succesAchatNFC',
                  query: {
                    numeroCommande: succes.data.numeroCommande
                  }
                }).catch(error => {
                  console.error('Erreur lors de la demande de carte:', error);
                });
          } else {
            router.push({
              name: 'succesAchatQRCode',
              query: {
                numeroCommande: succes.data.numeroCommande,
                qrCodeUrl: succes.data.qrCodeUrl
              }
            })
          }
        } else if (succes.data.typeVente === 'RECHARGEMENT') {
          router.push({
            name: 'succesRechargement',
            query: {
              numeroCommande: succes.data.numeroCommande
            }
          })
        } else if (succes.data.typeVente === 'FABRICATION_CARTE_VIDE') {
          router.push({
            name: 'succesfabrication_carte'
          })
        }
      },
      error => {
        console.error('ERREUR', error.response)
        loading.value = false
        error.value = true
        errorMessage.value = "Erreur avec le traitement de votre commande."
        if (error.response.status === 402) {
          errorMessage.value = "Votre paiement a été refusé.<br>Vous pouvez réessayer ou contactez nous à contact-rivconnect@keolis.com."
          return
        }if(error.response.status===500){
          errorMessage.value = "Erreur lors de votre paiement.<br>Vous pouvez réessayer ou contactez à contact-rivconnect@keolis.com."
        }
        if (error.response.data !== undefined) {
          errorMessage.value = error.response.data
        }
      }
    )
})
</script>

<template>
  <div>
    <!-- Loading -->
    <div class="container" v-if="loading">
      <div class="row">
        <div class="col text-center">
          <div class="spinner-border" label="Spinning"></div>
        </div>
      </div>
      <p class="text-center">Traitement de votre commande en cours</p>
    </div>

    <!-- Error -->
    <div class="container" v-else-if="error || errorMessage">
        <img src="@/assets/error.png" class="w-25" alt="erreur"/>
      <p class="text-center" v-html="errorMessage"></p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/main";

p {
  font-family: var(--font-title) sans-serif;
  text-align: center;
  margin-top: 3rem;
}

p {
  font-family: var(--font-title), sans-serif;
  font-size: 20px;
  color: var(--textcolor);
  margin-top: 1.5rem;
}

img {
  width: auto; /* Limite la taille maximale */
  height: auto;
  display: block; /* Nécessaire pour centrer */
  margin: 1.5rem auto; /* Centrage avec marges verticales */
}

ul {
  text-align: center;
  list-style-type: none;
  padding: 0;
}

a {
  color: var(--color-vert-logo);
  text-align: center;
  font-size: 25px;
}

a:hover {
  color: var(--color-bleu-logo);
  text-decoration: none;
}
</style>
